export default {
    API_URL: process.env.VUE_APP_API_URL_DEVELOPMENT
  }